/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestDataModel } from '../../models/request-data-model';

export interface PathologyIdGet$Params {
  id: string;
}

export function pathologyIdGet(http: HttpClient, rootUrl: string, params: PathologyIdGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<RequestDataModel>> {
  const rb = new RequestBuilder(rootUrl, pathologyIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PathologyStrictHttpResponse<RequestDataModel>;
    })
  );
}

pathologyIdGet.PATH = '/Pathology/{id}';
